import {
  ProductizedServiceDetails_productizedService$data,
  type ProductizedServiceDetails_productizedService$key,
} from '#app/__generated__/relay/ProductizedServiceDetails_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { formatProductizedServiceDuration } from '#app/utilities/formatProductizedServiceDuration.js';
import { CalendarIcon } from '@contra/icons/icons';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Timeline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const getDurationInfo = ({
  duration,
  price,
}: ProductizedServiceDetails_productizedService$data) => {
  if (price.type !== 'FIXED_PRICE') {
    return null;
  }

  if (!duration) {
    return price.timeline;
  }

  return formatProductizedServiceDuration(duration);
};

type ProductizedServiceDetailsProps = {
  readonly productizedServiceRef: ProductizedServiceDetails_productizedService$key;
};

export const ProductizedServiceDetails = ({
  productizedServiceRef,
}: ProductizedServiceDetailsProps) => {
  const isMobile = useIsMobile();
  const service = useFragment<ProductizedServiceDetails_productizedService$key>(
    graphql`
      fragment ProductizedServiceDetails_productizedService on ProductizedService {
        duration {
          interval
          amount
        }
        price {
          timeline
          type
        }
      }
    `,
    productizedServiceRef,
  );

  const durationInfo = getDurationInfo(service);

  if (!durationInfo) {
    return null;
  }

  return (
    <Container>
      <Text textStyle="subtitleRegular">Duration</Text>
      <Timeline>
        <CalendarIcon size={isMobile ? 22 : 14} />
        <Text textStyle="bodySmall">{durationInfo}</Text>
      </Timeline>
    </Container>
  );
};
